import * as React from 'react';
import { CountLabelStyle } from './style';
import { LAYOUT_TYPE } from './Item';

interface CountLabelProps {
  label?: React.ReactNode;
  length: number;
  max: number;
  layoutType?: LAYOUT_TYPE;
}

const CountLabel = ({ label, length, max, layoutType = LAYOUT_TYPE.VERTICAL }: CountLabelProps): JSX.Element => {
  return (
    <CountLabelStyle isVertical={layoutType === LAYOUT_TYPE.VERTICAL}>
      <span>{label}</span>
      <span>
        (<span className="length">{length || 0}</span> / {max})
      </span>
    </CountLabelStyle>
  );
};

export default CountLabel;
